var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWs = function SvgWs(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58167 12.4183 0 8 0C3.58173 0 0 3.58167 0 8C0 12.4183 3.58173 16 8 16ZM8 3.33337C5.42267 3.33337 3.33331 5.42273 3.33331 8C3.33331 10.5773 5.42267 12.6666 8 12.6666C10.5773 12.6666 12.6667 10.5773 12.6667 8C12.6667 5.42273 10.5773 3.33337 8 3.33337ZM9.13831 11.4865C10.4531 11.0575 11.4412 9.9054 11.6329 8.5H10.1389C10.0406 9.56299 9.69653 10.5848 9.13831 11.4865ZM10.1389 7.5H11.6329C11.4412 6.0946 10.4531 4.9425 9.13831 4.51355C9.69653 5.41516 10.0406 6.43701 10.1389 7.5ZM6.86169 4.51355C5.54688 4.9425 4.55878 6.0946 4.36713 7.5H5.86115C5.95935 6.43701 6.30347 5.41516 6.86169 4.51355ZM6.86609 7.5C6.97931 6.45459 7.37128 5.45886 8 4.61707C8.62872 5.45886 9.02069 6.45459 9.13391 7.5H6.86609ZM6.86609 8.5H9.13391C9.02069 9.54541 8.62872 10.5411 8 11.3829C7.37128 10.5411 6.97931 9.54541 6.86609 8.5ZM5.86115 8.5C5.95935 9.56299 6.30347 10.5848 6.86169 11.4865C5.54688 11.0575 4.55878 9.9054 4.36713 8.5H5.86115Z",
    fill: "#ffffff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ws.9d27a1a6.svg";
export { ForwardRef as ReactComponent };